
export class MemoWorkShift {
  applicantEmployeeCode: string;
  providerEmployeeCode: string;
  unitId: string;
  unitLabel: string;
  divisionId : string;
  divisionLabel: string;
  jobId: string;
  jobLabel: string;
  eventDate: Date;
  startHour: Date;
  endHour: Date;
  // interval: number;
  note: string;
}
